export default {
  paged: {
    select: 'id,name,description,isActive',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select: 'id,name,description,isActive,sourceProvider',
  },
  itemDetail: {
    select: 'id,name,description,isActive,sourceProvider,creator,modifier,created,updated',
  },
};
